import { BaseFragmentController } from 'src/app/View/BaseUI/BaseFragmentController';
import { ReserveUpdateDatePanelComponent } from './ReserveUpdateDatePanelComponent';
import {ReserveService} from '../../../../../../../Service/ReserveService';
import {ReservationSaveDTOInterface} from '../../../../../../../DTO/ReservationSaveDTOInterface';
import {MstDoctorDTOInterface} from '../../../../../../../DTO/MstDoctorDTOInterface';
import {ReservationFrameDTOInterface} from '../../../../../../../DTO/ReservationFrameDTOInterface';

/**
 * ReserveUpdateDateFormFragmentController
 * 問診画面のコントローラー
 */
export class ReserveUpdateDatePanelController extends BaseFragmentController {

	// 対となるView
	public combineView: ReserveUpdateDatePanelComponent;


	public async getInitialData(param: {
		view: any;
		reserve: ReservationSaveDTOInterface;
		startDate: Date;
		count: number;
	}): Promise<{
		data: ReservationFrameDTOInterface;
		doctorList: Array<MstDoctorDTOInterface>;
	}> {

		const reserveService = new ReserveService(param.view);
		const res = await reserveService.getReserveSelectDateViewData({
			reserve: param.reserve,
			startDate: param.startDate,
			count: param.count
		});

		return res;

	}

}
